// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* запрет перевода для всей программы */
* {
  -webkit-translate: none !important;
  translate: none !important;
}

.notranslate,
[data-nottranslate],
[translate="no"] {
  -webkit-user-select: auto;
  user-select: auto;
  text-decoration: none !important;
}

body, 
div, 
span, 
p, 
h1, h2, h3, h4, h5, h6,
table, thead, tbody, tr, td, th,
button, input, select, textarea,
label, a, li, ul, ol,
.schedule-cell,
.pair-info,
.pair-subject,
.pair-teacher,
.pair-room,
.grid-header {
  -webkit-translate: none !important;
  translate: none !important;
}

input, textarea, select {
  -webkit-translate: none !important;
  translate: none !important;
  text-transform: none !important;
}

button,
[data-nottranslate] {
  -webkit-user-select: auto;
  user-select: auto;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,uCAAuC;AACvC;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;EAcE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* запрет перевода для всей программы */\n* {\n  -webkit-translate: none !important;\n  translate: none !important;\n}\n\n.notranslate,\n[data-nottranslate],\n[translate=\"no\"] {\n  -webkit-user-select: auto;\n  user-select: auto;\n  text-decoration: none !important;\n}\n\nbody, \ndiv, \nspan, \np, \nh1, h2, h3, h4, h5, h6,\ntable, thead, tbody, tr, td, th,\nbutton, input, select, textarea,\nlabel, a, li, ul, ol,\n.schedule-cell,\n.pair-info,\n.pair-subject,\n.pair-teacher,\n.pair-room,\n.grid-header {\n  -webkit-translate: none !important;\n  translate: none !important;\n}\n\ninput, textarea, select {\n  -webkit-translate: none !important;\n  translate: none !important;\n  text-transform: none !important;\n}\n\nbutton,\n[data-nottranslate] {\n  -webkit-user-select: auto;\n  user-select: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
